module.exports = __webpack_public_path__ + "img/temperature.85397959.png";